module.exports = __webpack_public_path__ + "static/img/03.c7948950.png";